import { useGetCart } from '../components/CartQuery/CartQuery'
import { track } from '@toasttab/do-secundo-analytics'
import { getDaasAwareDiningOption } from './cart-helpers'
import { useCallback } from 'react'

export const getFlagsLoading = (featureFlags) =>
  Object.values(featureFlags).some((value) => value === null)

const getPromoBannerMetrics = (completedOrder, restaurantGuid) => {
  const { discounts, hasLoyaltyAttached } = completedOrder
  let promoBannersSessionData = {}

  try {
    promoBannersSessionData = JSON.parse(
      window.sessionStorage.getItem(`promo-banners-${restaurantGuid}`) || '{}'
    )
  } catch {}

  const appliedPromoCode = discounts?.restaurantDiscount?.promoCode
  const hasBannerPromoCode = appliedPromoCode
    ? Boolean(promoBannersSessionData?.promoCodesSeen[appliedPromoCode])
    : false

  return {
    hasBannerPromoCode,
    hasLoyaltyAttached: Boolean(hasLoyaltyAttached),
    promoCode: appliedPromoCode
  }
}

export const useTrackPurchase = () => {
  const { cart, restaurantGuid } = useGetCart()
  return useCallback(
    (completedOrder) => {
      const daasAwareDiningOptionBehavior = getDaasAwareDiningOption(cart)
      const { hasBannerPromoCode, hasLoyaltyAttached, promoCode } =
        getPromoBannerMetrics(completedOrder, restaurantGuid)
      const { createPasswordlessAccount, guid, selections, tax, tip, total } =
        completedOrder
      track('Completed Order', {
        id: guid,
        itemCount: selections.length,
        diningOptionBehavior: daasAwareDiningOptionBehavior,
        revenue: total,
        orderTax: tax,
        tip: tip || 0,
        createPasswordlessAccount,
        hasBannerPromoCode,
        hasLoyaltyAttached,
        promoCode
      })
    },
    [cart, restaurantGuid]
  )
}
